import { atom } from '@reatom/framework'

import type { WalletModel } from '@root/entities/wallet/atoms'

export const reatomWalletAssets = ({ wallet }: { wallet: WalletModel }) => {
  const searchQueryAtom = atom('', 'searchQueryAtom')

  const assetsAtom = atom((ctx) => {
    const searchQuery = ctx.spy(searchQueryAtom)

    const visibleAssets = ctx.spy(wallet.visibleAssets)
    if (!searchQuery) {
      return visibleAssets
    }
    return wallet.searchAssets(ctx, searchQuery)
  }, 'assetsAtom')

  return {
    assets: assetsAtom,
    searchQuery: searchQueryAtom,
  }
}

export type WalletAssetsModel = ReturnType<typeof reatomWalletAssets>
